import fourCutRanking from './4cut-ranking';
import arrow from './arrow';
import checkbox from './checkbox';
import common from './common';
import coupon from './coupon';
import home from './home';
import profile from './profile';
import sns from './sns';

export const Assets = {
  ...fourCutRanking,
  ...arrow,
  ...checkbox,
  ...common,
  ...coupon,
  ...home,
  ...profile,
  ...sns,
};
